import React from 'react';

import Predicates from 'constants/predicates';
import Types from 'constants/types';

import ActorInverseDisplay from './display/ActorInverseDisplay';
import RelatedObjectDisplay from './display/RelatedObjectDisplay';
import LocationDisplay from './display/LocationDisplay';

// Exceptions for display fields based on type/predicate
export default function SpectrumDisplay({field, mode, shaded}) {
  switch (field.type) {
    case Types.SPECTRUM.RELATED_OBJECT:
      return <RelatedObjectDisplay field={field} />;

    case Types.SPECTRUM.GEOMETRY:
      return <LocationDisplay field={field} />;
  }

  switch (field.predicate) {
  case Predicates.SPECTRUM.ACTOR_INVERSE:
    return <ActorInverseDisplay field={field} mode={mode} shaded={shaded} />;
  }

  return null;
};